import { OverlayContainer } from "@angular/cdk/overlay";
import { ApplicationConfig, inject, provideAppInitializer } from "@angular/core";
import { ReferenceDataActions, ReferenceDataState } from "@core/reference-data";
import { DataService } from "@core/data";
import { OverlayOverrideContainer } from "@core/overlay-override";
import { CONFIGURATION_SERVICE, TruHedgeConfigurationService } from "@core/system-configuration";
import { Store } from "@ngrx/store";
import * as Sentry from "@sentry/angular";
import { sharedProviders } from "@shared-config";

const providers = [
	DataService,
	{ provide: CONFIGURATION_SERVICE, useExisting: TruHedgeConfigurationService },
	provideAppInitializer(async () => {
		inject(Sentry.TraceService);
		const referenceDataStore = inject(Store<ReferenceDataState>);
		const truHedgeConfigurationService: TruHedgeConfigurationService = inject(TruHedgeConfigurationService);
		const configUrl: string = getWidgetConfigurationFile();

		await truHedgeConfigurationService.loadAppConfig(configUrl);

		Sentry.init({
			dsn: truHedgeConfigurationService.sentryDsn,
			sendDefaultPii: true,
			integrations: [Sentry.browserTracingIntegration()],
			environment: truHedgeConfigurationService.environment,

			replaysSessionSampleRate: truHedgeConfigurationService.sentryReplaysSessionSampleRate,
			replaysOnErrorSampleRate: truHedgeConfigurationService.sentryReplaysOnErrorSampleRate,
			tracesSampleRate: truHedgeConfigurationService.sentryTracesSampleRate
		});
		referenceDataStore.dispatch(ReferenceDataActions.loadReferenceData());
	}),
	{ provide: OverlayContainer, useClass: OverlayOverrideContainer }
];

function getWidgetConfigurationFile(): string {
	const script = document.querySelector<HTMLScriptElement>("script#tenora-widget");
	const candidate = script?.dataset["tenoraConfigUrl"];

	if (candidate === undefined || candidate.trim() === "") {
		throw new Error('Missing required "data-tenora-config-url" attribute on script#tenora-widget');
	}

	try {
		new URL(candidate);
		return candidate;
	} catch {
		throw new Error(`Invalid configuration URL: ${candidate}`);
	}
}

export const appConfig: ApplicationConfig = {
	providers: [...providers, ...sharedProviders]
};
